import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import { toast } from "react-toastify";

export class Repair extends Component {
    static displayName = Repair.name;
    state = {

    };

    componentDidMount() {
        //this.getCard();
    }



    render() {

        return (
            <>
                <CustomModal dd="modal-sm" show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="" >
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">اعزام به تعمیرگاه</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">در این حالت ریموت فقط برای قفل و بازکردن استفاده می شود و آژیر و راهنما و کلیه قسمت های 
                                دزدگیر غیرفعال می شود و دکمه قفل و بدون صدا را همزمان  با هم یک ثانیه فشار دهید با 
                                صدای تیک آژیر فعال و با 2 چریپ غیرفعال می شود.</div>
                            </div>
                        </div>

                        <div className="row">

                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                    <button className="btn btn-dark" onClick={(e) => this.props.closeModal(e)}>تایید</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>
        );
    }


}